import { render, staticRenderFns } from "./EditBuyerFormCard.vue?vue&type=template&id=d90ed276&"
import script from "./EditBuyerFormCard.vue?vue&type=script&lang=ts&"
export * from "./EditBuyerFormCard.vue?vue&type=script&lang=ts&"
import style0 from "./EditBuyerFormCard.vue?vue&type=style&index=0&id=d90ed276&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports